var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('account-table')],1),_c('v-flex',{attrs:{"xs6":""}},[_c('counter-account-table')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }